import { DocumentNode } from '@apollo/client';

import { HOSTS_DATA } from '../../hooks/useHostsData/schema';

export type BookingRefetchQuery =
  | DocumentNode
  | { query: DocumentNode; fetchPolicy: 'no-cache' };

export const getBookingRefetchQueries = (
  pathname: string,
  fallback: DocumentNode[]
): BookingRefetchQuery[] =>
  pathname === '/computers' || pathname === '/map'
    ? [{ query: HOSTS_DATA, fetchPolicy: 'no-cache' }]
    : fallback;
